/**
 * contractGuaranteedHoursDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

contractGuaranteesDirective.$inject = [];

export function contractGuaranteesDirective() {
    return {
        // language=HTML
        template: `
            <!--
            <md-nav-bar md-selected-nav-item="ui.type">
                <md-nav-item name="hours" md-nav-click="hours">Guaranteed Hours</md-nav-item>
                <md-nav-item name="pay" md-nav-click="pay">Guaranteed Pay</md-nav-item>
            </md-nav-bar>
            -->
            
            <div class="form-row">
                <!--
                <div class="flex-50 form-row-column" ng-class="{ 'disabled': ui.type !== 'hours' }">
                    <app-input-number label="Hours per week"
                                      form="form"
                                      name="guaranteed_hours_week"
                                      value="_value.hours"
                                      ng-disabled="ui.type !== 'hours'"
                                      min="0"
                                      max="168"
                                      step=".25">
                    </app-input-number>

                    <app-alert hint>
                        <small>
                            Remaining hours per week will be calculated at the default hourly rate. This will
                            only apply if the contract is selected as the carer's default.
                        </small>
                    </app-alert>
                </div>

                <div class="flex-50 form-row-column" ng-class="{ 'disabled': ui.type !== 'pay' }">
                    <app-input-currency label="Amount per week"
                                        form="form"
                                        name="guaranteed_pay_week"
                                        value="_value.pay"
                                        ng-disabled="ui.type !== 'pay'"
                                        min="0">
                    </app-input-currency>

                    <app-alert hint>
                        <small>
                            Carer will be paid at least the specified value per-week.
                        </small>
                    </app-alert>
                </div>
                
                -->
                
                <div ng-class="{ 'disabled': ui.type !== 'pay' }">
                    <app-input-currency label="Amount per week"
                                        form="form"
                                        name="guaranteed_pay_week"
                                        value="_value.pay"
                                        ng-disabled="ui.type !== 'pay'"
                                        min="0">
                    </app-input-currency>

                    <app-alert hint>
                        <small>
                            Carer will be paid at least the specified value for each week.
                        </small>
                    </app-alert>
                </div>
            </div>
        `,
        scope: {
            contract: '=contract',
            form: '=form',
        },
        link: function(scope) {
            scope.$watch('contract', _contractWatcher);
            scope.$watch('_value', _valueWatcher, true);
            scope.$watch('ui.type', _valueWatcher);

            // Currently only pay is supported
            // TODO: Re-enable hours when support is introduced in payroll calculation.
            scope.ui = {
                type: 'pay',
            };

            scope._value = {
                pay: null,
                hours: null,
            };

            function _contractWatcher(contract) {
                if (contract) {
                    scope._value.pay = contract.guaranteed_pay_week;
                    scope._value.hours = contract.guaranteed_hours_week;
                } else {
                    scope._value.pay = null;
                    scope._value.hours = null;
                }
            }

            function _valueWatcher() {
                if (scope.contract) {
                    switch (scope.ui.type) {
                        case 'hours':
                            scope.contract.guaranteed_hours_week = scope._value.hours;
                            scope.contract.guaranteed_pay_week = null;
                            break;

                        case 'pay':
                            scope.contract.guaranteed_hours_week = null;
                            scope.contract.guaranteed_pay_week = scope._value.pay;
                            break;
                    }
                }
            }
        },
    };
}
